import React from 'react'
import {useTranslation} from 'react-i18next'

import DescriptionIcon from '@mui/icons-material/Description'
import {Box, Card, Stack, Typography, Theme} from '@mui/material'
import {getProductLineColors} from '@progynyglobal/pg-ui-library'
import {useProductLine} from 'hooks/useProductLine'
import {makeStyles} from 'tss-react/mui'

import {useMeStore} from '@progyny/store/meStore'

const useStyles = makeStyles<{colors: any}>()((theme: Theme, {colors}) => ({
  documentBox: {
    backgroundColor: '#F5F5F5',
    borderRadius: 8,
    padding: theme.spacing(2),
    marginTop: theme.spacing(2),
    border: '1px solid #E0E0E0',
  },
  documentIcon: {
    backgroundColor: theme.palette.common.white,
    borderRadius: 8,
    padding: theme.spacing(1.5),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 56,
    height: 56,
    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
  },
  fileName: {
    fontSize: 14,
    fontWeight: 400,
    color: colors?.primary,
    cursor: 'pointer',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
}))

const MemberFile = () => {
  const user = useMeStore((s) => s.user)
  const {t} = useTranslation()
  const {productLine} = useProductLine()
  const colors = getProductLineColors(productLine)
  const {classes} = useStyles({colors})

  const navigateToPreview = (fileUrl: string) => {
    window.open(fileUrl, '_blank')
  }

  return (
    <Box mb={4}>
      <Typography fontSize={16} fontWeight={600}>
        {t('profile_member_file_id_document')}
      </Typography>
      <Card className={classes.documentBox} elevation={0}>
        <Stack flexDirection={'row'} gap={2} alignItems={'center'}>
          <Box className={classes.documentIcon}>
            <DescriptionIcon sx={{fontSize: 32, color: colors.primary}} />
          </Box>
          <Typography
            className={classes.fileName}
            onClick={() =>
              navigateToPreview(user?.member?.identityDocumentUrl!)
            }
          >
            {user?.member?.identityDocumentFileName}
          </Typography>
        </Stack>
      </Card>
    </Box>
  )
}

export default MemberFile
